var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 20,
    viewBox: "0 0 27 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 13.9998L17.5867 9.99984L10.6667 5.99984V13.9998ZM26.08 3.55984C26.2533 4.1865 26.3733 5.0265 26.4533 6.09317C26.5467 7.15984 26.5867 8.07984 26.5867 8.87984L26.6667 9.99984C26.6667 12.9198 26.4533 15.0665 26.08 16.4398C25.7467 17.6398 24.9733 18.4132 23.7733 18.7465C23.1467 18.9198 22 19.0398 20.24 19.1198C18.5067 19.2132 16.92 19.2532 15.4533 19.2532L13.3333 19.3332C7.74667 19.3332 4.26667 19.1198 2.89333 18.7465C1.69333 18.4132 0.92 17.6398 0.586667 16.4398C0.413333 15.8132 0.293333 14.9732 0.213333 13.9065C0.12 12.8398 0.0799999 11.9198 0.0799999 11.1198L0 9.99984C0 7.07984 0.213333 4.93317 0.586667 3.55984C0.92 2.35984 1.69333 1.5865 2.89333 1.25317C3.52 1.07984 4.66667 0.959837 6.42667 0.879837C8.16 0.786504 9.74667 0.746504 11.2133 0.746504L13.3333 0.666504C18.92 0.666504 22.4 0.879837 23.7733 1.25317C24.9733 1.5865 25.7467 2.35984 26.08 3.55984Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.48f676d8c0c3bc58d0d9b28ed614b1e4.svg";
export { ForwardRef as ReactComponent };